import { useEffect, useState } from 'react';
import { FlameIcon } from 'lucide-react';

/**
 * Scarcity trigger: an almost-full progress bar with a limited-spots message.
 * The number of remaining spots ticks down slightly over time (never below 3)
 * to reinforce urgency.
 */
export function ScarcityBar() {
  const [spots, setSpots] = useState(7);
  useEffect(() => {
    const id = window.setInterval(() => {
      setSpots(prev => prev > 3 ? prev - 1 : prev);
    }, 45000);
    return () => window.clearInterval(id);
  }, []);
  const pct = Math.min(96, 100 - spots * 0.9);
  return <div className="rounded-xl border border-amber-500/30 bg-[#16161a] p-4" data-id="element-198" data-mp="2261z1jy8xw8g">
      <div className="mb-2 flex items-center justify-between text-sm" data-id="element-199" data-mp="227wo9agjwaic">
        <span className="flex items-center gap-1.5 font-cond font-semibold uppercase tracking-wide text-amber-400" data-id="element-200" data-mp="275y31j6y1no0">
          <FlameIcon className="h-4 w-4 spark" data-id="element-201" data-mp="fgsgdh9g06d" />
          Cupos casi agotados
        </span>
        <span className="font-cond font-semibold text-white" data-id="element-202" data-mp="5d9yn6ikcu6n">
          Quedan {spots} cupos
        </span>
      </div>
      <div className="h-3 w-full overflow-hidden rounded-full bg-[#0d0d0f]" data-id="element-203" data-mp="33ks6f5vwfzmr">
        <div className="h-full rounded-full bg-gradient-to-r from-amber-600 to-amber-400 transition-all duration-700" style={{
        width: `${pct}%`
      }} data-id="element-204" data-mp="2zkrubrw9w0iv" />
      </div>
      <p className="mt-2 text-center text-xs text-neutral-400" data-id="element-205" data-mp="38ewgvz4dipsl">
        Faltan solo <span className="font-semibold text-amber-400" data-id="element-206" data-mp="2kn8vtxtsm8y8">{spots} cupos</span> para
        cerrar el precio promocional de lanzamiento.
      </p>
    </div>;
}